<app-navigation></app-navigation>
<app-maintenance></app-maintenance>
<div class="container mainContent unselectable">
  <mat-form-field id="selection">
    <mat-select [(ngModel)]="companySelection" (selectionChange)="companySelectionChange()" name="companySelection" placeholder="Filter">
      <mat-option *ngFor="let company of companies" [value]="company.value">{{company.text}}</mat-option>
    </mat-select>
  </mat-form-field>
  <app-news-element class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4" *ngFor="let newsitem of news" [news]="newsitem"></app-news-element>
  <app-scroll-to-top></app-scroll-to-top>
</div>
<app-footer></app-footer>
